if (!customElements.get("touch-slider")) {
	customElements.define(
		"touch-slider",
		class TouchSlider extends HTMLElement {
			constructor() {
				super();

				this.items = this.querySelectorAll(".touch-slider__item");
			}

			connectedCallback() {
				if (!this.items) return;

				let isDown = false;
				let isDragging = false;
				let startX;
				let scrollLeft;

				const stop = () => {
					isDown = false;
				};
				this.addEventListener("pointerup", stop);
				this.addEventListener("pointercancel", stop);
				this.addEventListener("pointerleave", stop);
				this.addEventListener("dragstart", (event) => event.preventDefault());
				this.addEventListener("click", (event) => {
					// Avec data-links, les liens restent cliquables tant qu'on n'a pas glissé
					if (this.hasAttribute("data-links") && !isDragging) return;
					event.stopPropagation();
					event.preventDefault();
				});

				this.addEventListener("pointerdown", (e) => {
					isDown = true;
					isDragging = false;
					startX = e.pageX - this.offsetLeft;
					scrollLeft = this.scrollLeft;
				});

				this.addEventListener("pointermove", (e) => {
					if (!isDown) return;
					const x = e.pageX - this.offsetLeft;
					// Seuil de 5px pour distinguer un clic d'un glisser
					if (!isDragging) {
						if (Math.abs(x - startX) < 5) return;
						isDragging = true;
						this.setPointerCapture(e.pointerId);
					}
					e.preventDefault();
					this.scrollLeft = scrollLeft - (x - startX);
				});
			}
		},
	);
}
